import React from 'react';
import NumberField from 'core/components/fields/numberField';
import {MdTextField, MdCheckbox} from 'core/components/fields/fields';
import {NumberFormat, Min, Max, MinDateOrPrevious} from 'core/form/rules';
import {FIELDDEFDISPLAYTYPE} from 'core/form/form';
import {FieldText, FormProps, ClosedContentProps, lovParam, lovLabel} from 'core/form/formUtils';
import ActiveItem from 'core/components/blockComp/activeItem';
import {Validate} from 'core/form/validate';
import {valid, invalid, AreSame, HasLength, ForbiddenNames} from 'core/form/rules';
import securityService from 'core/security/securityService';
import moment from "moment";
import {User} from "core/security/securityDomain";
import {observer} from "mobx-react";
import {createForm} from 'core/form/createForm';
import StyledSelect from "core/components/fields/styledSelect";
import {optionsSearch} from "core/common/service/commonDataService";
import NewPartyDialog from "party/component/newPartyDialog";
import FlatButton from "material-ui/FlatButton";
import {Party, PARTYCATEGORY, PARTYROLE, PartyRole} from "party/partyDomain";
import {action} from "mobx";
import {LovItem} from "core/metamodel/mdEntity";
import StyledDatePicker from 'core/components/fields/styledDatePicker';
import {ClosedFormField} from "core/form/closedForm";

function UserExist({value}): any {
  if (!value) return valid();
  return securityService.userExist(value)
    .then( (exists) => (exists) ? invalid(`User ${value} already exists`) : valid());
}


const ClosedContent = ({dataObject, entity, entities, fields, disabled}: ClosedContentProps<User>) => (
  <div style={{display: 'flex', flexDirection: 'column'}}>

    <h5 style={{marginTop: 0, fontSize: '18px', fontWeight: 'bold', display: 'flex'}}>
      <span style={{marginRight: 10}} >{dataObject.username}</span>
      { (dataObject.party) ? (<ClosedFormField label='Owner' value={dataObject.party.label} linkProps={{to:'partyDetail', params:{id: dataObject.party.value} }} />) : null}
    </h5>

    <div className="form-text-row">
      <FieldText value={ (dataObject.enabled) ? 'Enabled' : 'Disabled' }/>
      <FieldText value={ (dataObject.locked) ? 'Locked' : '' }/>
      <FieldText value={ (dataObject.expired) ? 'Expired' : '' }/>
      <FieldText label="Session expiration" value={moment.duration(dataObject.expirationMinutes, 'minutes').humanize(true) + ( (dataObject.rememberMe) ? ' (persists when browser closed)' : '(closed on browser close)' )} />
      <FieldText label={fields.accountExpiration.textLabel} value={dataObject.accountExpiration ? moment(dataObject.accountExpiration).format("DD.MM.YYYY") : undefined}/>
    </div>

  </div>
);

@createForm({
  formName: 'UserForm',
  fields: [{
    name: 'username',
    validators: ['IsRequired']
  }, {
    name: 'party',
    validators: ['IsRequired'],
    usePlaceholder: true
  },{
    name: 'enabled',
    displayType: FIELDDEFDISPLAYTYPE.checkbox
  }, {
    name: 'locked',
    displayType: FIELDDEFDISPLAYTYPE.checkbox
  }, {
    name: 'expired',
    displayType: FIELDDEFDISPLAYTYPE.checkbox
  }, {
    name: 'password1',
    validators: ['IsRequired']
  }, {
    name: 'password2',
    validators: ['IsRequired']
  },{
    name: 'accountExpiration'
  },{
    name: 'rememberMe',
    displayType: FIELDDEFDISPLAYTYPE.checkbox
  }, {
    name: 'expirationMinutes',
    validators: ['IsRequired', 'IsNumber']
  }
  ]
}, ClosedContent)
@observer
export default class UserForm extends React.Component<FormProps<User, User>, undefined> {

  private newPartyDialogRef: NewPartyDialog;

  newPartyDialogRefHandler = (comp) => this.newPartyDialogRef = comp;

  @action newParty = () => {
    let {dataObject, rootObject, entities, formName} = this.props;
    let roleType = entities.get('PartyRoleType').getLovItem(PARTYROLE.USER_ROLE);

    let newPartyObject = new Party({
      active: true,
      $new: true,
      partyCategory: PARTYCATEGORY.PE,
      roles: [new PartyRole({roleType}).initDefaultValues()]
    }).initAfterRead(true);

    console.log("newParty roleType = %O", roleType);

    new Promise((resolve, reject) => {
      this.newPartyDialogRef.open(resolve, reject, newPartyObject);
    }).then(action("close-new-party-diaglog", (newPartyLov: LovItem) => {
      dataObject.party = newPartyLov;
      dataObject.getForm(formName).updateFieldsPropValue(dataObject, "party");
      rootObject.$dirty = true;
      console.debug("update PartyRel %O", dataObject);
    })).catch( (e) => {});
  };

  render() {

    let {dataObject, rootObject, entities, entity, formName} = this.props;
    let fields = dataObject.getFormFields(formName);
    let {username, enabled, locked, expired, password1, password2, rememberMe, expirationMinutes, accountExpiration, party} = fields;

    console.log("ON RENDER: User form fields", fields);

    let openContent = (
      <div>

        {/*  1. row  */}
        <div className="row">
          <div className="xs col-xs-6 col-sm-4">
            <MdTextField {...username.props} disabled={!dataObject.$new} />
            <Validate field={username} value={username.props.value}>
              {(dataObject.$new) ? <UserExist/> : null}
              <ForbiddenNames names={["system"]}/>
            </Validate>
          </div>
          <div className="fx col-xs-12 col-sm-8">
            <NewPartyDialog ref={this.newPartyDialogRefHandler}/>
            <h5 style={{marginLeft: 25, alignSelf: 'center'}}>Party to link</h5>
            <div style={{marginLeft: 15, flexGrow: 1}}>
              <StyledSelect  {...party.props} async={true}
                             loadOptions={optionsSearch.bind(this, 'Party', {partyCategory: [PARTYCATEGORY.PE, PARTYCATEGORY.EN]})}
                             advancedSearchGL="partySearch" hintText="type to start search..."/>
              <Validate field={party} value={party.props.value}/>
            </div>
            <FlatButton
              labelStyle={{fontSize: 20}}
              style={{alignSelf: 'center'}}
              label=" or create a new one"
              secondary={true}
              onClick={this.newParty}
            />
          </div>
        </div>

        {/*  2. row  */}
        <div className="row">
          <div className="col-xs-6 col-sm-4">
            <MdCheckbox {...enabled.props} />
          </div>
          <div className="col-xs-6 col-sm-4">
            <MdCheckbox {...locked.props} />
          </div>
          <div className="col-xs-6 col-sm-4">
            <MdCheckbox {...expired.props} />
          </div>
        </div>

        {/*  2. row  */}
        <div className="row">
          <div className="xs col-xs-6 col-sm-4">
            <NumberField {...expirationMinutes.props} />
            <Validate field={expirationMinutes} value={expirationMinutes.props.value}>
              <NumberFormat precision={10} scale={0}/>
              <Min min={1}/>
              <Max max={1000000}/>
            </Validate>
          </div>
          <div className="col-xs-6 col-sm-4">
            <MdCheckbox {...rememberMe.props} />
          </div>
          <div className="col-xs-6 col-sm-4">
            <StyledDatePicker min={moment().add(1, "days").toDate()} {...accountExpiration.props} />
            <Validate field={accountExpiration} value={accountExpiration.props.value}>
              <MinDateOrPrevious min={moment().add(1, "days")} previous={moment(accountExpiration.props.value)} />
            </Validate>
          </div>
        </div>



        {/*  3. row  */}
        { (dataObject.$new) ?
          <div className="row">
            <div className="col-xs-6 col-sm-4">
              <MdTextField type="password" {...password1.props} />
              <Validate field={password1} value={password1.props.value}>
                <HasLength min={8}/>
              </Validate>
            </div>
            <div className="col-xs-6 col-sm-4">
              <MdTextField type="password" {...password2.props} />
              <Validate field={password2} value={password2.props.value} needTouch={[['AreSame', 'value1'], ['AreSame', 'value2']]}>
                <HasLength min={8}/>
                <AreSame value1={password1.props.value} value2={password2.props.value} />
              </Validate>
            </div>
          </div>
          : null
        }

      </div>
    );

    return (
        <ActiveItem openContent={openContent} closedContent={<ClosedContent {...{dataObject, entity, entities, fields}} />} {...this.props} validate={this.props.validate} />
    );
  }
}



// WEBPACK FOOTER //
// ./src/core/security/userForm.tsx